// extracted by mini-css-extract-plugin
export default {"journeyProgress":"styles_journeyProgress__3z1ql","label":"styles_label__nnHuv","track":"styles_track__kZyUD","fill":"styles_fill__O8E6L"};